import { Card } from '@/components/Card';
import { Heading } from '@/components/Heading';
import { EditOutline, DeleteIcon, CopyIcon, MeatballMenu, CheckOutline } from '@/components/Icons';
import { THEME_VARIABLE, LOCAL_AR } from '@/config';
import useLanguageStore from '@/stores/useLanguageStore';

import { useQueryClient } from '@tanstack/react-query';
import { Col, Divider, Dropdown, Flex, MenuProps, message, Row, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Role } from '@/types/roleManagement';

interface TeamMembersData {
  fName?: string;
  lName?: string;
  phoneNumber?: string;
  email?: string;
  role?: Role[];
  uid: string;
}
interface Props extends TeamMembersData {
  onDelete: () => void;
  isDeleting: boolean;
  onEdit: () => void;
}
const TeamMemberCardItem = ({ fName, lName, role, onDelete, uid, isDeleting, onEdit }: Props) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { language } = useLanguageStore();

  const menuItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Heading
          title={t('edit')}
          leadingIcon={<EditOutline color={THEME_VARIABLE.customTunaPrimary} />}
          rotation={false}
          extraClassName='capitalize'
        />
      ),
      onClick: () => {
        onEdit();
      },
    },
    {
      type: 'divider',
    },
    {
      key: '2',
      label: (
        <Heading
          extraClassName='capitalize'
          title={t('delete')}
          leadingIcon={<DeleteIcon color={THEME_VARIABLE.customTunaPrimary} />}
          rotation={false}
          loading={isDeleting}
        />
      ),
      onClick: () => {
        if (!isDeleting) onDelete();
      },
    },
  ];

  const hasOwnerRole = role?.some((role) => role.name === 'owner');

  const getRoleLabel = () => {
    if (!role) return '---';
    const roleNames = role.map((role) => {
      // Show description for Arabic, name for English
      if (language === LOCAL_AR && role.description) {
        return role.description;
      }
      // if (role.name === 'admin' || role.name === 'owner') {
      //   return t(`roles_item.${role.name}`);
      // }
      return role.name;
    });
    return roleNames.join(', ');
  };
  return (
    <Card extraClassName='rounded-[10px] h-[90px] flex justify-center' noMargin>
      <Flex justify='space-between' align='center'>
        <Flex vertical gap={'0.25rem'}>
          <Typography.Text className='text-base font-bold text-customTunaPrimary'>
            {fName + ' ' + lName}
          </Typography.Text>

          <Typography.Text className='text-base font-light text-customTunaPrimary'>
            {getRoleLabel()}
          </Typography.Text>

          {/* <CopyIcon /> */}
        </Flex>
        {hasOwnerRole ? null : (
          <Dropdown
            menu={{ items: menuItems }}
            trigger={['click']}
            rootClassName='bottomSheet'
            placement='bottomLeft'
          >
            <Flex className='cursor-pointer'>
              <MeatballMenu width={20.48} height={20.48} />
            </Flex>
          </Dropdown>
        )}
      </Flex>
    </Card>
  );
};

export default TeamMemberCardItem;
